import React, { useContext } from "react";
import { Autocomplete, TextField } from "@mui/material";
import GroupBiorepositoryOps from "../FieldTags/GroupBiorepositoryOps";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const ServiceRequestNumber = ({ serviceRequestNumber, handleChange, pullLists, informedConsent, informedConsentApprover, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = informedConsent !== "No" && informedConsentApprover !== "No" && checkRole(user, [ROLES.BIOOPS, ROLES.APPROVER, ROLES.DCT]);

    return (
        <div className="planField">
            <GroupBiorepositoryOps />
            <Autocomplete
                name="serviceRequestNumber"
                multiple
                freeSolo
                autoSelect
                options={[]}
                value={serviceRequestNumber ? serviceRequestNumber.split(",") : []}
                onChange={(_, newValue) => handleChange("serviceRequestNumber", newValue)}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label={pullListLabels.serviceRequestNumber}
                        InputLabelProps={{
                            shrink: true,
                            required: required,
                        }}
                        required={required}
                    />
                }
                disabled={!canEdit}
            />
            <HistoryLogElement pullLists={pullLists} label={"serviceRequestNumber"} />
        </div>
    );
};

export default ServiceRequestNumber;